import React, { useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { LogOut, Heart, ShoppingBag, LayoutDashboard, User } from "lucide-react";
import { setSeo } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useCart } from "@/context/CartContext";

export default function Account() {
  const { user, loading, logout } = useAuth();
  const { wishlist, count } = useCart();
  const navigate = useNavigate();

  useEffect(() => setSeo("My Account | Adam's The Islamic Boutique", "Manage your Adam's account."), []);
  useEffect(() => { if (!loading && !user) navigate("/login"); }, [user, loading, navigate]);

  if (loading || !user) return <div className="py-24 text-center text-espresso/50">Loading...</div>;

  const doLogout = async () => { await logout(); navigate("/"); };

  return (
    <div className="max-w-3xl mx-auto px-6 py-10 lg:py-16">
      <div className="flex items-center gap-4 mb-10">
        <div className="w-16 h-16 rounded-full bg-champagne/15 flex items-center justify-center"><User className="w-7 h-7 text-champagne" /></div>
        <div>
          <p className="overline">My Account</p>
          <h1 className="font-serif text-3xl text-espresso" data-testid="account-name">Hello, {user.name}</h1>
          <p className="text-sm text-espresso/50">{user.email}</p>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {user.role === "admin" && (
          <Link to="/admin" className="bg-espresso text-ivory rounded-2xl p-6 flex items-center gap-4 sm:col-span-2" data-testid="account-admin-link">
            <LayoutDashboard className="w-6 h-6 text-champagne" />
            <div><p className="font-serif text-xl">Admin Dashboard</p><p className="text-ivory/60 text-sm">Manage products, orders & discounts</p></div>
          </Link>
        )}
        <Link to="/wishlist" className="bg-beige/50 rounded-2xl p-6 flex items-center gap-4 hover:bg-beige transition-colors">
          <Heart className="w-6 h-6 text-champagne" />
          <div><p className="font-serif text-lg text-espresso">Wishlist</p><p className="text-espresso/50 text-sm">{wishlist.length} saved items</p></div>
        </Link>
        <Link to="/cart" className="bg-beige/50 rounded-2xl p-6 flex items-center gap-4 hover:bg-beige transition-colors">
          <ShoppingBag className="w-6 h-6 text-champagne" />
          <div><p className="font-serif text-lg text-espresso">Shopping Bag</p><p className="text-espresso/50 text-sm">{count} items</p></div>
        </Link>
      </div>

      <button onClick={doLogout} className="mt-8 flex items-center gap-2 text-sm text-[#a13b2f] hover:opacity-70" data-testid="account-logout">
        <LogOut className="w-4 h-4" /> Sign Out
      </button>
    </div>
  );
}
